import { createStyles } from '@mantine/core';
import { useCallback, useState } from 'react';

import dt from '~/testing';
import useUpdateContestInviteStatus from '~/domains/contest/hooks/useUpdateContestInviteStatus';

import type { ContestInvite } from '../../common/components/ContestInviteCard/types';
import ContestInviteCard from '../../common/components/ContestInviteCard/ContestInviteCard';

const useStyles = createStyles((theme) => ({
  grid: {
    display: 'grid',
    alignItems: 'stretch',
    gap: theme.spacing.md,
    gridTemplateColumns: 'repeat(3, 1fr)',

    [theme.fn.smallerThan('lg')]: {
      gridTemplateColumns: '1fr 1fr',
    },

    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
}));

type MyContestInvitesProps = {
  invites: ContestInvite[];
};

function MyContestInvites({ invites }: MyContestInvitesProps) {
  const { classes } = useStyles();
  const [processingInviteId, setProcessingInviteId] = useState<string | null>(null);

  const mutation = useUpdateContestInviteStatus({
    onSuccess: () => {
      setProcessingInviteId(null);
    },
    onError: () => {
      setProcessingInviteId(null);
    },
  });

  const handleDecline = useCallback(
    (inviteId: string) => {
      setProcessingInviteId(inviteId);
      mutation.mutate({
        contestInviteId: inviteId,
        payload: { status: 'DECLINED' },
      });
    },
    [mutation]
  );

  return (
    <div className={classes.grid} data-test-id={dt.myContests.layout.content.grid.main}>
      {invites?.map((invite) => (
        <ContestInviteCard
          key={invite.id}
          invite={invite}
          contest={invite.contest}
          onAccept={() => {}}
          onDecline={handleDecline}
          isLoading={mutation.isLoading && processingInviteId === invite.id}
        />
      ))}
    </div>
  );
}

export default MyContestInvites;
